import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarOne = _resolveComponent("NavbarOne")!
  const _component_PageBanner = _resolveComponent("PageBanner")!
  const _component_OurServices = _resolveComponent("OurServices")!
  const _component_PricingPlans = _resolveComponent("PricingPlans")!
  const _component_TestOurService = _resolveComponent("TestOurService")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_SubscribeContent = _resolveComponent("SubscribeContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarOne),
    _createVNode(_component_PageBanner, {
      pageTitle: "خدماتنا",
      subTitle: "استكشف خدمات IPTV المتكاملة واستمتع بآلاف القنوات العربية والعالمية، الأفلام، المسلسلات، والبث المباشر بجودة HD و4K.",
      pageBannerImage: _ctx.pageBannerImg
    }, null, 8, ["pageBannerImage"]),
    _createVNode(_component_OurServices),
    _createVNode(_component_PricingPlans),
    _createVNode(_component_TestOurService),
    _createVNode(_component_FAQ),
    _createVNode(_component_SubscribeContent),
    _createVNode(_component_MainFooter, { class: "bg-black" }),
    _createVNode(_component_CopyRight)
  ], 64))
}